import { Injectable } from '@angular/core';
declare var wpuser: any;

@Injectable({
  providedIn: 'root'
})



export class WploginService {

  wplogin = false;
  constructor() {}

  public getLoginStatus(): boolean {
    wpuser.user_roles.forEach( element => {
      if (element === 'datenzugang') {
        this.wplogin = true;
      } else {
        this.wplogin = false;
      }
    });
    return this.wplogin;
  }

 }



